import React from "react"
import Link from "gatsby-link"
import Img from "gatsby-image"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm } from "../utils/typography"
import { graphql } from "gatsby"

class SubPage extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const siteTagline = data.site.siteMetadata.description
    const stories = data.allContentfulPosts.edges
    return (
      <Layout
        location={this.props.location}
        title={siteTitle}
        tagline={siteTagline}
      >
        <SEO
          title="Stories"
          keywords={["blog", "gatsby", "javascript", "react"]}
        />
        <div>
          <h1>Stories</h1>
          <div className="postListing">
            {stories.map(({ node }) => {
              const title = node.title || node.slug
              const url = "/story/" + node.slug
              return (
                <div key={node.slug} className="story">
                  <Img fixed={node.featuredImage.fixed} />
                  <div className="content">
                    <h3
                      style={{
                        marginBottom: rhythm(1 / 4),
                      }}
                    >
                      <Link style={{ boxShadow: "none" }} to={url}>
                        {title}
                      </Link>
                    </h3>
                    <small>{node.date}</small>
                    <p
                      style={{
                        fontSize: rhythm(1 / 2),
                      }}
                      dangerouslySetInnerHTML={{
                        __html: node.body.childMarkdownRemark.excerpt,
                      }}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </Layout>
    )
  }
}

export default SubPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
      }
    }
    allContentfulPosts(
      sort: { fields: [date], order: DESC }
      filter: { type: { eq: "story" } }
    ) {
      edges {
        node {
          id
          title
          slug
          date(formatString: "MMMM Do, YYYY")
          featuredImage {
            fixed(width: 300) {
              src
            }
          }
          body {
            childMarkdownRemark {
              html
              excerpt(pruneLength: 250)
            }
          }
        }
      }
    }
  }
`
